import JassEnum from './enum';

/**
 * type damagetype
 */
export default class JassDamageType extends JassEnum {}
